/**
 * DraggableCheckboxes - компонент для сортировки и управления списком чекбоксов.
 *
 * @prop {Array} modelValue - Список элементов с ключами `key`, `title`, `checked`, `disabled`.
 * @event update:modelValue - Событие обновления списка элементов.
 */
<template>
	<div class="ao-draggable-checkboxes">
		<div
			v-if="title"
			class="ao-h4 mb-1"
		>
			{{ title }}
		</div>
		<draggable
			v-model="items"
			item-key="key"
			class="ao-draggable-checkboxes"
		>
			<template v-slot:item="{ element }">
				<ao-drag-n-drop-list-item>
					<ao-checkbox
						:key="element.key"
						:modelValue="element.checked"
						:label="element.title"
						hide-details
						class="my-1"
						density="compact"
						color="secondary"
						:disabled="disabledCallback(element, items)"
						@update:modelValue="groupItemChange(element)"
					/>
				</ao-drag-n-drop-list-item>
			</template>
		</draggable>
	</div>
</template>

<script setup>
import { computed } from 'vue'
import draggable from 'vuedraggable'

import { copyObject } from '@/helpers/utilsHelper'

const props = defineProps({
	/**
	 * Список элементов, содержащий объекты с ключами:
	 * - `key` (String | Number) - уникальный идентификатор элемента
	 * - `title` (String) - текст
	 * - `checked` (Boolean) - состояние чекбокса
	 * - `disabled` (Boolean) - отключение элемента
	 */
	modelValue: {
		type: Array,
		required: true,
	},

	title: {
		type: String,
		default: null,
	},

	/**
	 * Функция обратного вызова для блокировки чекбокса.
	 *
	 * @param {Object} item - Элемент списка
	 * @param {Array} items - Список элементов
	 * @returns {Boolean} - Результат проверки
	 */
	disabledCallback: {
		type: Function,
		default: ({ disabled }) => (disabled),
	},
})

const emit = defineEmits({
	'update:modelValue': null,
})

const items = computed({
	get: () => {
		return copyObject(props.modelValue)
	},
	set: (value) => {
		emit('update:modelValue', value)
	},
})

const groupItemChange = (el) => {
	const groups = copyObject(items.value)
	const group = groups.find(({ key }) => key === el.key)
	group.checked = !group.checked
	items.value = groups
}
</script>
